import { useState } from "react";
import UserManagementHeader from "../../UserManagementHeader";
import UserTextHeader from "../../UserManagementHeader/UserTextHeader";
import Administrator from "./Administrator";
import BasicUser from "./BasicUser";
import StandardUser from "./StandardUser";
import {
  PermisionBody,
  PermissionHeaderText,
  PermissionMain,
  PermissionMainHeader,
  PermissionSubText,
  PermissionTitle,
  PermissionTitleHeader,
} from "./permision.styles";

const Permission = () => {
  const [activeSection, setActiveSection] = useState("Administrator");

  const handleSectionClick = (section: any) => {
    setActiveSection(section);
  };

  return (
    <div>
      <UserTextHeader />
      <UserManagementHeader />
      <div style={{ width: "77vw", paddingLeft: "20px" }}>
        <PermissionMain>
          <PermissionMainHeader>
            <PermissionHeaderText>Permission</PermissionHeaderText>
          </PermissionMainHeader>
          <PermisionBody>
            <PermissionTitleHeader>
              <PermissionTitle
                onClick={() => handleSectionClick("Administrator")}
                isActive={activeSection === "Administrator"}
              >
                Administrator
              </PermissionTitle>
              <PermissionTitle
                onClick={() => handleSectionClick("Standard User")}
                isActive={activeSection === "Standard User"}
              >
                Standard User
              </PermissionTitle>
              <PermissionTitle
                onClick={() => handleSectionClick("Basic User")}
                isActive={activeSection === "Basic User"}
              >
                Basic User
              </PermissionTitle>
            </PermissionTitleHeader>
            <PermissionSubText>
              Every member gets basic permissions and functionality by default.
              You can customize settings for all members or make local
              adjustments for individual users in their profiles.
            </PermissionSubText>
            {activeSection === "Administrator" && <Administrator />}
            {activeSection === "Standard User" && <StandardUser />}
            {activeSection === "Basic User" && <BasicUser />}
          </PermisionBody>
        </PermissionMain>
      </div>
    </div>
  );
};

export default Permission;
